import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import Dashboard from './Dashboard';
import TeacherManagement from './TeacherManagement';
import EmpIdMapping from './EmpIdMapping';
import UserManagement from './UserManagement';
import TaskManagement from './TaskManagement';
import Settings from './Settings';
import EnrollmentSync from './EnrollmentSync';
import MachineAudit from './MachineAudit';
import './AdminDashboard.css';

const APP_VERSION = 'v1.6.32';

function AdminDashboard() {
    const [activeMenu, setActiveMenu] = useState('dashboard');
    const [adminUser, setAdminUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        const user = localStorage.getItem('adminUser');
        
        if (!token) {
            navigate('/admin');
            return;
        }

        if (user) {
            try {
                setAdminUser(JSON.parse(user));
            } catch (e) {
                console.error('Error parsing admin user:', e);
            }
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        navigate('/admin');
    };

    const handleBackToApp = () => {
        navigate('/');
    };

    const adminMenuItems = [
        { id: 'dashboard', label: 'Dashboard', icon: 'pi-home' },
        { id: 'teachers', label: 'Teacher Management', icon: 'pi-users' },
        { id: 'emp-id-mapping', label: 'Enrolment ID Mapping', icon: 'pi-id-card' },
        { id: 'users', label: 'User Management', icon: 'pi-user-plus' },
        { id: 'roles', label: 'Role Management', icon: 'pi-key' },
        { id: 'enrollment', label: 'Enrollment Sync', icon: 'pi-link' },
        { id: 'machine-audit', label: 'Machine Audit', icon: 'pi-desktop' },
        { id: 'tasks', label: 'Task Center', icon: 'pi-th-large' },
        { id: 'settings', label: 'Settings', icon: 'pi-cog' },
    ];

    const renderContent = () => {
        switch (activeMenu) {
            case 'dashboard':
                return <Dashboard />;
            case 'teachers':
                return <TeacherManagement />;
            case 'emp-id-mapping':
                return <EmpIdMapping />;
            case 'users':
                return <UserManagement />;
            case 'roles':
                return <ComingSoon title="Role Management" />;
            case 'enrollment':
                return <EnrollmentSync />;
            case 'machine-audit':
                return <MachineAudit />;
            case 'tasks':
                return <TaskManagement />;
            case 'settings':
                return <Settings />;
            default:
                return <Dashboard />;
        }
    };

    return (
        <div className="admin-dashboard">
            {/* Sidebar Menu */}
            <div className="admin-sidebar">
                <div className="admin-sidebar-header">
                    <i className="pi pi-shield"></i>
                    <h2>Admin Panel</h2>
                </div>
                <nav className="admin-sidebar-nav">
                    {/* Admin Menu */}
                    <div className="admin-menu-section">
                        <div className="admin-menu-label">Administration</div>
                        {adminMenuItems.map(item => (
                            <div
                                key={item.id}
                                className={`admin-nav-item ${activeMenu === item.id ? 'active' : ''}`}
                                onClick={() => setActiveMenu(item.id)}
                            >
                                <i className={`pi ${item.icon}`}></i>
                                <span>{item.label}</span>
                            </div>
                        ))}
                    </div>
                </nav>
                <div className="admin-sidebar-footer">
                    <div className="admin-nav-item" onClick={handleBackToApp}>
                        <i className="pi pi-arrow-left"></i>
                        <span>Back to App</span>
                    </div>
                    <div style={{ padding: '8px 20px', fontSize: '0.75rem', color: '#8899aa', textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                        {APP_VERSION}
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="admin-main">
                <div className="admin-dashboard-header">
                    <div className="admin-header-left">
                        <div>
                            <h1>
                                {(activeMenu === 'enrollment' || activeMenu === 'machine-audit') && <i className="pi pi-sync" style={{ marginRight: '8px', fontSize: '1.2rem' }}></i>}
                                {adminMenuItems.find(m => m.id === activeMenu)?.label || 'Dashboard'}
                            </h1>
                            <p>
                                {activeMenu === 'enrollment' 
                                    ? 'Detects teachers who punch on fingerprint machines but are missing from the app database. Register them here to link their punch data to teacher records.'
                                    : activeMenu === 'machine-audit'
                                    ? 'Upload the machine user .dat file to compare with server data. Identifies status mismatches, missing enrollments, and unlinked teachers.'
                                    : 'NEDP School Management System'}
                            </p>
                        </div>
                    </div>
                    <div className="admin-header-right">
                        {adminUser && (
                            <span className="admin-user-info">
                                <i className="pi pi-user"></i>
                                {adminUser.username} ({adminUser.roleName})
                            </span>
                        )}
                        <Button
                            icon="pi pi-sign-out"
                            label="Logout"
                            className="p-button-outlined p-button-danger"
                            onClick={handleLogout}
                        />
                    </div>
                </div>

                <div className="admin-dashboard-content">
                    {renderContent()}
                </div>
            </div>
        </div>
    );
}

function ComingSoon({ title }) {
    return (
        <div className="admin-coming-soon">
            <i className="pi pi-clock"></i>
            <h2>{title}</h2>
            <p>This feature is coming soon...</p>
        </div>
    );
}

export default AdminDashboard;
